import { render, staticRenderFns } from "./textColorController.vue?vue&type=template&id=068b4d75&"
import script from "./textColorController.vue?vue&type=script&lang=ts&"
export * from "./textColorController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports